<script>
import { list } from '@/api/segmento'

export default {
  props: {
    model: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    async autocomplete ({ searchValue, qtd, page }) {
      let result = await list({ segmento: searchValue, qtd, page })
      return result.data
    }
  }
}
</script>

<template>
  <ui-auto-complete-busca
    ref="fieldBusca"
    :model="model"
    field="segmento"
    width="1000"
    component="app-segmento-grid"
    label="Segmento"
    @change="v => $emit('change', v)"
    :autocomplete="autocomplete" />
</template>
